<template>
  <ams-select-table
    :heading="select_table_heading"
    :ams_api_path="ams_api_path"
    :ams_type="ams_type"
    :ams_fields="ams_fields"
    :filtering="filtering"
    :pre_selected_items="pre_selection"
    :select_mode="mode_selection"
    @selectedRows="selectRows"
  />
</template>

<script>
import AmsSelectTable from './AmsSelectTable.vue'

export default {
  components: {
    AmsSelectTable
  },
  props: {
    pre_selection: {
      Type: Array
    },
    filtering: {
      Type: Object
    },
    select_table_heading: {
      Type: String
    }
  },
  data() {
    return {
      mode_selection: 'single',
      ams_type: 'interests',
      ams_api_path: 'api/public/v1',
      ams_fields: [
        {
          key: 'attributes.ancestry',
          label: 'Ancestry',
          sortable: false,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc',
          // A column that needs custom formatting,
          formatter: 'classification',
        },
        { 
          key: 'attributes.aliases',
          label: 'Interest Aliases',
          sortable: false,
          filterable: false,
          class: 'text-left',
          sortDirection: 'asc' 
        },
        { 
          key: 'attributes.name',
          label: 'Interest Name',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        }
      ],
    }
  },
  methods: {
    selectRows(items) {
      this.$emit('selectedItems', items)
    }
  }
}
</script>